"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

// fork: marketing funnel analytics for the public booking surface only. Mounted in the
// booking-page-wrapper layout, so the logged-in app shell stays untracked and upstream's
// stray posthog.capture() calls there remain no-ops (posthog is never initialised for them).
//
// Deliberately cookieless: memory-only persistence and no autocapture means no identifier
// outlives the tab and no form content is ever collected, so the public pages need no
// consent UI. The key is baked as a placeholder and swapped in by scripts/start.sh at
// container start; an unset key arrives here as an empty string and disables analytics.
export default function PostHogBookingAnalytics() {
  useEffect(() => {
    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    if (!key || key.endsWith("_PLACEHOLDER") || posthog.__loaded) return;
    posthog.init(key, {
      api_host: "/ingest",
      ui_host: "https://eu.posthog.com",
      defaults: "2025-05-24",
      persistence: "memory",
      autocapture: false,
    });
  }, []);

  return null;
}
